export default __webpack_public_path__ + "static/media/property_957.ec0451ce.png";